import React from 'react';

const Education = () => {
  const courses = [
    'Algorithms & Data Structures',
    'Software Engineering Principles',
    'Database Systems & Design (Oracle)',
    'Software Testing & Quality Assurance',
    'Software Development Project'
  ];

  return (
    <section id="education" className="education">
      <div className="container">
        <h2 className="section-title">Education</h2>
        <div className="education-content">
          <div className="education-item">
            <div className="education-header">
              <h3 className="education-degree">Master of Science in Computer Science</h3>
              <span className="education-gpa">GPA: 3.9/4.0</span>
            </div>
            <h4 className="education-school">Texas State University — San Marcos, TX</h4>
            <p className="education-date">Jan 2024 - Dec 2025</p>
            <div className="education-courses">
              <h5>Relevant Coursework:</h5>
              <div className="courses-list">
                {courses.map((course, index) => (
                  <span key={index} className="course-tag">{course}</span>
                ))}
              </div>
            </div>
          </div>
          <div className="education-item">
            <div className="education-header">
              <h3 className="education-degree">Bachelor of Science in Information Technology</h3>
            </div>
            <h4 className="education-school">Osmania University — Hyderabad, India</h4>
            <p className="education-date">Aug 2018 - Jan 2022</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;

